import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import LegacyPaginator from 'components/others/Paginator';
import type { ComponentType } from 'react';
import type { PaginatorType } from '@econtractor/types';
import WarrantyTable from '../WarrantyTable';
import OffWarrantyCard from '../OffWarrantyCard';
import OffAttachWarranties from './OffAttachWarranties';
import { useObjectWarranties } from './model';

const Paginator = LegacyPaginator as ComponentType<{
    paginator: PaginatorType;
    onChangePage: (page: number) => void;
    showPageSize: boolean;
}>;

interface ObjectWarrantiesProps {
    objectId: number;
    canEdit: boolean;
}

const ObjectWarranties = ({ objectId, canEdit }: ObjectWarrantiesProps) => {
    const { t } = useTranslation('Warranties');
    const state = useObjectWarranties(objectId);
    return (
        <>
            {canEdit && (
                <div className="d-flex justify-content-end align-items-center gap-2">
                    <div className="mb-2">
                        <Button
                            variant="primary"
                            size="sm"
                            className="py-2"
                            onClick={() => state.setShowAttach(true)}
                        >
                            <SolarIcon name="box-seam" className="me-2" />
                            {t('add')}
                        </Button>
                    </div>
                </div>
            )}
            <WarrantyTable
                mini
                rows={state.result?.warranties || []}
                loading={state.loading}
                onOpen={state.setCardId}
                onDetach={
                    canEdit
                        ? (id) => {
                              void state.mutate([id], true);
                          }
                        : undefined
                }
            />
            {state.result && state.result.paginator.countPages > 1 && (
                <Paginator
                    paginator={state.result.paginator}
                    onChangePage={state.setPage}
                    showPageSize={false}
                />
            )}
            <OffAttachWarranties
                show={state.showAttach}
                objectId={objectId}
                onClose={() => state.setShowAttach(false)}
                onSaved={state.refresh}
            />
            {state.cardId !== null && (
                <OffWarrantyCard
                    id={state.cardId}
                    onClose={() => state.setCardId(null)}
                    onSaved={state.refresh}
                />
            )}
        </>
    );
};

export default ObjectWarranties;
